import { o as o_util } from "../chunks/common-namespaces-client-C7k75bsz.mjs";
const cookie = o_util.cookie ?? {};
const exists = cookie.exists;
const get = cookie.get;
const remove = cookie.remove;
const set = cookie.set;
export {
  cookie,
  exists,
  get,
  remove,
  set
};
/*                                      */
